'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  markAsShipped,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { reloadPage } from '@marketplace-web/browser/browser-navigation-util'

import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import ConfirmParcelSentModal from './ConfirmParcelSentModal'

type Props = ConversationActionProps

const MarkAsShipped = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  async function handleMarkAsShipped() {
    if (!transactionId) return

    await markAsShipped({ transactionId })

    reloadPage()
  }

  function trackMarkAsShippedButtonClick() {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        screen: 'message_reply',
        target: 'mark_transaction_as_shipped',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  function handleButtonClick() {
    trackMarkAsShippedButtonClick()
    setIsModalOpen(true)
  }

  function closeModal() {
    setIsModalOpen(false)
  }

  if (!transactionId) return null

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleButtonClick}
      />
      <ConfirmParcelSentModal
        transactionId={transactionId}
        isOpen={isModalOpen}
        onSubmit={handleMarkAsShipped}
        onClose={closeModal}
      />
    </>
  )
}

export default MarkAsShipped
